







































import { Component, Vue, PropSync, Prop } from "vue-property-decorator";

@Component
class StrategySelect extends Vue {
  @PropSync("strategy") bindStrategy;

  @Prop() strategies;

  dialog = false;

  handleSelect(strategy) {
    this.bindStrategy = strategy;
    this.dialog = false;
  }
}
export default StrategySelect;
